import { render, staticRenderFns } from "./ClientServicesLayout.vue?vue&type=template&id=280b7a10&scoped=true&"
import script from "./ClientServicesLayout.vue?vue&type=script&lang=js&"
export * from "./ClientServicesLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClientServicesLayout.vue?vue&type=style&index=0&id=280b7a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b7a10",
  null
  
)

export default component.exports